import moment from 'moment';


export const calculateAge = (birthday) => {
  const bday = moment(birthday).add(1, 'days');
  // need to add 1 day for calculating full years and months
  const years = moment().diff(bday, 'year');
  bday.add(years, 'years');
  const months = moment().diff(bday, 'months');

  return { years, months };
};

export const getAgeFormatted = (birthdayDate, intl) => {
  if (!intl || !birthdayDate) return null;

  const age = calculateAge(+birthdayDate);
  const { years, months } = age;

  const defaultMessage = `** ${ age.years } Years and ${ age.months } months.`;
  const values = { yearsValue: age.years, monthsValue: age.months };

  switch (true) {
    case (years === 0 && months === 0):
      return intl.formatMessage({
        id: 'Appointment.View.Details.Customer.Age.LessThan1Month',
        defaultMessage,
      });
    case (years === 0):
      return intl.formatMessage({
        id: 'Appointment.View.Details.Customer.Age.DescriptionMonth',
        defaultMessage,
      }, { ...values });

    case (months === 0):
      return intl.formatMessage({
        id: 'Appointment.View.Details.Customer.Age.DescriptionYear',
        defaultMessage,
      }, { ...values });
    default:
      return intl.formatMessage({
        id: 'Appointment.View.Details.Customer.Age.DescriptionYearMonth',
        defaultMessage,
      }, { ...values });
  }
};
